'use client'

import { useEffect, useRef, useState } from 'react'

interface FitTextProps {
    children: string
    className?: string
}

export default function FitText({ children, className = '' }: FitTextProps) {
    const containerRef = useRef<HTMLDivElement>(null)
    const textRef = useRef<HTMLHeadingElement>(null)
    const [ready, setReady] = useState(false)

    useEffect(() => {
        const resize = () => {
            const el = textRef.current
            const container = containerRef.current
            if (!el || !container) return
            const containerWidth = container.offsetWidth
            let low = 10
            let high = 120
            el.style.whiteSpace = 'nowrap'
            while (high - low > 1) {
                const mid = Math.ceil((low + high) / 2)
                el.style.fontSize = `${mid}px`
                if (el.scrollWidth > containerWidth) {
                    high = mid
                } else {
                    low = mid
                }
            }
            el.style.fontSize = `${low + 1}px`
            setReady(true)
        }
        resize()
        window.addEventListener('resize', resize)
        return () => window.removeEventListener('resize', resize)
    }, [children])

    return (
        <div ref={containerRef} className="w-full">
            {/* SVG fallback shown before JS measures */}
            {!ready && (
                <svg
                    viewBox={`0 0 ${children.length * 11.5} 20`}
                    className="w-full max-w-full h-auto"
                    preserveAspectRatio="xMinYMid meet"
                    aria-hidden="true"
                >
                    <text x="0" y="15" className="fill-background" style={{ fontFamily: 'var(--font-sans)', fontWeight: 'bold' }}>{children}</text>
                </svg>
            )}
            <h1
                ref={textRef}
                className={className}
                style={{
                    lineHeight: 1,
                    visibility: ready ? 'visible' : 'hidden',
                    position: ready ? 'static' : 'absolute',
                }}
            >
                {children}
            </h1>
        </div>
    )
}
